import customSelect from 'custom-select';

export default {
  init() {
    customSelect('.formContainer__form-select');
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
